/* All the Configs and Access Token Keys will be set here */
//react-encrypt
//import GitInfo from "react-git-info/macro";

export const gitInfo = {commit: {date:new Date()}}; //GitInfo();

export const YRBServicesDropboxKey = "FlDOpRzlUJAAAAAAAAAA-tohl-3TCjcwbefpjlrEC8nmg29jCBwJmE9fMHqbU0ZV";
export const HPMEngineersDropboxKey = "FlDOpRzlUJAAAAAAAAAA9w67pdEwizmKkOBsLtQe3eRUXsbulawg_2s2rnQ2WWKp";
export const SentryKey = "https://6bd3d64d693f4a8392b7a798db66dca4@o337257.ingest.sentry.io/5283024";
export const SentryAuthKey = "c3dff55090d64b4cb307f2a7f04b005149e0e46cc410423387ff766dbceb212e";
export const NetlifyAPIKey = "6a7459631d5d001138b43603145498bb7dbb945730eb28b235606e27b4f4bb7b";
export const CloudFlareKey = "IFg_qstownqTMEb1h-lGIFf4GzVbLjjhFcJyXji3";
export const UDC_CORS_PATH = 'https://udc-cors.herokuapp.com/';
export const JIRAAPIToken = 'gcCOg9k4fVFCa4PQL0xp4D99';

export const Status = [
    "Active", 
    "Pending", 
    "Removed", 
    "Inactive", 
    "Fired", 
    "Locked"
];

export const CompanyRolesMap = {
    "Anonymous": [
        'Guest'
    ],
    "Undash-cop Private Limited": [
        'Super Admin', 
        'Admin', 
        'Guest', 
        'Dashboard',
        'Employee', 
        'Sales Manager', 
        'Recruiter Manager', 
        'Marketing Executive',
        'Marketing Manager', 
        'Support Manager', 
        'IT and Networks',
        'Finance and Payroll', 
        'Developer', 
        'YRB Services',
        'YRB Services Admin', 
        'YRB Services Engineer', 
        'UDC Studio Developer',
        'Adyan Shoppers',
        'Adyan Shoppers Developer',
        'HPM Engineers',
        'HPM Engineers Admin',
    ],
    "Awesome Travels": [
        'Dashboard',
        'Guest', 
        'Employee', 
        'Sales Manager', 
        'Marketing Manager', 
        'Support Manager', 
        'Developer'
    ],
    "YRB Services": [
        'YRB Services',
        'YRB Services Admin', 
        'YRB Services Engineer'
    ],
    "Razi-soft LLP": [
        'Admin', 
        'Guest', 
        'Employee', 
        'Finance and Payroll'
    ],
    "Adyan Shoppers": [
        'Dashboard',
        'Guest', 
        'Employee', 
        'Sales Manager', 
        'Recruiter Manager', 
        'Marketing Executive',
        'Marketing Manager', 
        'Support Manager', 
        'Developer',
        'Adyan Shoppers',
        'Adyan Shoppers Developer'
    ],
    "V Pro Statutory Consultants": [
        'Guest', 
        'Employee', 
        'Developer'
    ],
    "HPM Engineers": [
        'HPM Engineers',
        'HPM Engineers Admin',
    ],
    "Sumukha IT Solutions": [
        'YRB Services'
    ]
};

export const LandingPageConfig = {
    "": '/guest',
    "UDC0251001CCR": '/dashboard',
    "UDC0251004CCR": '/yrbservices',
    "UDC0251006CCR": '/guest', 
    "UDC0251007CCR": '/hpmengineers',
};

export const CompanyStatus = [
    "Not Started",
    "Active",
    "Initial Startup",
    "Hosted Newly",
    "Active Looking",
    "Closing",
    "Closed"
];

export const IndustryType = [
    "Software Development",
    "Software Managment",
    "BPO",
    "Networking",
    "Technical Services",
    "Finance",
    "E-Commerce",
    "Civil Grounds",
    "Unique",
    "General Purpose",
    "Insurance",
    "HealthCare IT",
    "Transport and Logistics",
    "Hospitality",
    "Medical",
    "Others"
];

export const ContractType = [
    "Fully Client Corporation",
    "Term Client Corporation",
    "Parent Contract",
    "BM Contract",
    "Duplex Contract",
    "Personal Takeover",
    "Client Wings"
];

export const ContractStatus = [
    "On Live Forever",
    "Term Expiration",
    "Yearly Contract",
    "Expired",
    "Contract Fired",
    "Not Applicable",
    "DisClosed"
];

export const TransactionType = [
    "CR",
    "DR",
    "BAL"
];

export const ModeOfPayment = [
    "Cash",
    "Cheque",
    "DD",
    "NEFT",
    "RTGS",
    "Net Banking",
    "Google Pay",
    "PhonePe",
    "Amazon Pay",
    "Paytm",
    "PayPal",
    "Razor Pay",
    "Others"
];

export const ConfigSystems = {
    "eup": "EUP Dashboard",
    "Razi-soft": "Razi-soft",
    "YRBServices-Internal": "YRB Services Internal App",
    "UDC-logistics": "UDC Logistics",
    "Adyan-dashboard": "Adyan Dashboard",
    "Adyan-product-tracker": "Adyan Product Tracker",
};

export const DNSTypes = ["A", "AAAA", "CAA", "CERT", "CNAME", "DNSKEY", "DS", "LOC", "MX", "NAPTR", "NS", "PTR", "SMIMEA", "SPF", "SRV", "SSHFP", "TLSA", "TXT", "URI"];

export const TTL = {
    "Auto": 1,
    "2 min": 120,
    "5 min": 300,
    "10 min": 600,
    "15 min": 900,
    "30 min": 1800,
    "1 hr": 3600,
    "2 hr": 7200,
    "5 hr": 18000,
    "12 hr": 43200,
    "1 day": 86400
};

export const RulesStatus = [
    "Pending for Approval", 
    "Archive", 
    "Active", 
    "In Future"
];

export const PosterStatus = [
    "Submitted",
    "Pending for Approval", 
    "Archive", 
    "Posted", 
    "Rejected"
];

export const HostingPlatform = [
    "Facebook",
    "Instagram",
    "LinkedIn",
    "Google Ads",
    "Twitter",
    "MailChimp",
    "Others",
    "Universal",
    "I am not knowledgeable"
];

export default {
    gitInfo, YRBServicesDropboxKey, HPMEngineersDropboxKey, Status, CompanyRolesMap, LandingPageConfig, CompanyStatus, IndustryType, ContractType, 
    ContractStatus, TransactionType, ModeOfPayment, ConfigSystems, SentryKey, NetlifyAPIKey, CloudFlareKey, DNSTypes, TTL, SentryAuthKey, RulesStatus,
    PosterStatus, HostingPlatform
};